function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.036.96v28.545M11.108 2.079l3.94 3.649M18.977 2.079l-3.94 3.649M11.108 28.397l3.94-3.65M18.977 28.397l-3.94-3.65M1.692 8.1l26.695 14.273M.775 11.811l5.383-1.336M4.71 5.5l1.442 4.985M25.387 24.97l-1.443-4.984M29.321 18.659l-5.383 1.336M1.692 22.364L28.387 8.091M.775 18.654l5.383 1.335M4.71 24.965l1.442-4.985M25.387 5.495l-1.443 4.984M29.321 11.806l-5.383-1.336",
  stroke: "currentColor",
  strokeWidth: "1.454",
  strokeLinecap: "round"
})));